export const storeCreditsDurationTypes = {
  days: 'days',
  months: 'months',
  years: 'years',
}
